export function getCookieValue(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

export function setCookie(
  name: string,
  value: string,
  options: {
    path?: string;
    maxAge?: number;
    sameSite?: string;
    secure?: boolean;
  } = {}
): void {
  const {
    path = '/',
    maxAge = 31536000,
    sameSite = 'Lax',
    secure = true,
  } = options;
  let cookie = `${name}=${value}; path=${path}; max-age=${maxAge}; SameSite=${sameSite}`;
  if (secure) {
    cookie += '; Secure';
  }
  document.cookie = cookie;
}
